module.exports = __webpack_public_path__ + "static/images/components/ButtonTiny/images/default-borders.2efaeea3.png";


//////////////////
// WEBPACK FOOTER
// ./components/ButtonTiny/images/default-borders.png
// module id = 2575
// module chunks = 11